import React, { useState, useEffect } from "react";
import "./Development.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Background from "../../Background/Background";
import Contact from "../../4.Contact/Contact";
import Modal from "../../Modal/Modal";
// Import Images
import img1 from "../../../assets/img1.jpg";
import img2 from "../../../assets/responsive-website-design.jpg";
import img3 from "../../../assets/TotalGYMp.png";
import img4 from "../../../assets/GOp.png";

const Development = () => {
  const [showModal, setShowModal] = useState(false);

  const [alignItems, setAlignItems] = useState("start");

  const [is768px, setIs768px] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setAlignItems("center");
        setIs768px(true);
      } else {
        setAlignItems("start");
        setIs768px(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleContactClick = () => {
    setShowModal(true);
  };
  return (
    <>
      <Background />
      <div className="container-d container">
        <h2 className="text-center txt-h2-d fw-bold title-d">DESARROLLO</h2>
        <Container
          fluid
          className="text-center d-flex flex-column align-items-center justify-content-center"
        >
          <Row className="align-items-center justify-content-center grid-h grid-align-1">
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center`}
            >
              <h3 className={`fw-bold text-uppercase ${is768px ? "" : "ms-5"}`}>
                Aplicaciones a medida
              </h3>
              <div
                className={`d-flex flex-column align-items-${alignItems} justify-content-center`}
              >
                <p
                  className={`text-${alignItems} mt-3 ${is768px ? "" : "ms-5"}`}
                >
                  ¿Por qué conformarte con lo que ves en el mercado?
                </p>
                <p
                  className={`text-${is768px ? "center" : "start"} ${
                    is768px ? "" : "ms-5"
                  }`}
                >
                  Nadie mejor que vos conoce su negocio, hacemos tu aplicacion
                  web a medida! Accesible desde todos lados y todos los
                  dispositivos. Una aplicación a medida ofrece soluciones
                  específicas, mejorando la eficiencia, productividad y
                  experiencia del usuario, adaptándose perfectamente a sus
                  necesidades.
                </p>
              </div>
              <Button
                size="sm"
                className="btn-d mt-3 fs-5 fw-bold margin-bd"
                onClick={handleContactClick}
              >
                CONTACTO
              </Button>
            </Col>
            <Col>
              <img
                src={img1}
                className="img-logo img-grid-1 shadow"
                alt="Imagen ilustrativa"
              />
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center grid-h grid-align-2">
            <Col>
              <img
                src={img2}
                className="img-logo img-grid-2"
                alt="Imagen ilustrativa"
              />
            </Col>
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center`}
            >
              <h3 className={`fw-bold text-uppercase ${is768px ? "" : "ms-5"}`}>
                Paginas Web
              </h3>
              <div
                className={`d-flex flex-column align-items-${alignItems} justify-content-center`}
              >
                <p className={`text-start mt-3 ${is768px ? "" : "ms-5"}`}>
                  ¿Por qué tener una pagina web?
                </p>
                <p
                  className={`text-${is768px ? "center" : "start"} ${
                    is768px ? "" : "ms-5"
                  }`}
                >
                  Porque es esencial para tu negocio. Te permite mostrar tu
                  marca y productos las 24 horas, llegar a más clientes, generar
                  confianza y facilitar la interacción.{is768px && <br />} ¡Haz
                  que tu negocio destaque en línea! <br />
                  El diseño responsive de nuestros sitios va a hacer que tus
                  clientes puedan verlo, en pc, tablet y celulares sin importar
                  su tamaño.
                </p>
              </div>
              <Button
                size="sm"
                className="btn-d mt-3 fs-5 fw-bold img-responsive margin-bd2"
                onClick={handleContactClick}
              >
                CONTACTO
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bkg2sec pb-5">
        <h3 className="mt-5 pt-5 text-center fw-bold sub-title-d text-uppercase">
          Nuestros Productos 🥇
        </h3>
        <Container
          fluid
          className="text-center d-flex flex-column align-items-center justify-content-center container"
        >
          <Row className="align-items-center justify-content-center grid-h grid-align-3">
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center`}
            >
              <h3
                className={`fw-bold text-light text-uppercase ${
                  is768px ? "" : "ms-5"
                }`}
              >
                Total GYM
              </h3>
              <div
                className={`d-flex flex-column align-items-${alignItems} justify-content-center`}
              >
                <p
                  className={`text-light text-${is768px ? "center" : "start"} ${
                    is768px ? "" : "ms-5"
                  }`}
                >
                  Con nuestra aplicación de administración de gimnasios,
                  gestionar socios, finanzas, dietas, rutinas y clases es fácil
                  y eficiente. Además, automatiza recordatorios por WhatsApp
                  para mantener a tus socios comprometidos. Optimiza tu gestión
                  y mejora la experiencia de tus clientes con nuestra solución
                  todo en uno. ¡Únete a nosotros y lleva tu gimnasio al
                  siguiente nivel!
                </p>
              </div>
              <Button
                size="sm"
                className="btn-d-black mt-3 fs-5 fw-bold text-dark"
                onClick={handleContactClick}
              >
                CONTACTO
              </Button>
            </Col>
            <Col>
              <img
                src={img3}
                className="img-logo shadow img-grid-3"
                alt="Imagen ilustrativa"
              />
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center grid-h grid-align-4">
            <Col>
              <img
                src={img4}
                className="img-logo img-grid-4"
                alt="Imagen ilustrativa"
              />
            </Col>
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center`}
            >
              <h3
                className={`fw-bold text-light text-uppercase ${
                  is768px ? "" : "ms-5"
                }`}
              >
                GO!
              </h3>
              <div
                className={`d-flex flex-column align-items-${alignItems} justify-content-center`}
              >
                <p
                  className={`text-light text-${is768px ? "center" : "start"} ${
                    is768px ? "" : "ms-5"
                  }`}
                >
                  Descubre nuestra completa solución de gestión para soderías.
                  Con nuestra aplicación, administra clientes, ventas y accede a
                  informes clave fácilmente. La versión móvil permite a tus
                  vendedores registrar ventas sobre la marcha. Simplifica tu
                  operativa y potencia tus ventas con nuestra plataforma
                  adaptable y amigable. ¡Impulsa tu sodería hacia el éxito hoy
                  mismo!
                </p>
              </div>
              <Button
                size="sm"
                className="btn-d-black mt-3 fs-5 fw-bold img-responsive text-dark"
                onClick={handleContactClick}
              >
                CONTACTO
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
      <Contact />
      <Modal show={showModal} setShow={setShowModal} />
    </>
  );
};

export default Development;
